import { useRouter } from 'next/router';
import { useLang } from '@/i18n';
import EcoImg from 'eco-design-components/base/eco-img';
import { useState, useEffect } from 'react';
import css from './index.module.scss';

const F: React.FC = () => {
    const { locale = '' } = useRouter();
    const { t } = useLang('rapidpro');
    const [enter, setEnter] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined' && window?.AniContainer) {
            const IS_PC = window.innerWidth >= 768;
            if (IS_PC) {
                const sceneArr: any[] = [];
                sceneArr.push(
                    AniContainer.create({
                        triggerElement: '.rapid-pro-F',
                        triggerHook: 1,
                        offset: '100%',
                        onEnter: () => setEnter(true),
                        onLeave: () => setEnter(false),
                    }),
                );
                if (locale !== 'ph') {
                    sceneArr.push(
                        AniContainer.create({
                            triggerElement: '.rapid-pro-F',
                            triggerHook: 1,
                            offset: '170%',
                            duration: '10%',
                            syncFromTo: [
                                ['.rapid-pro-F .box1', { opacity: 1 }, { opacity: 0 }, 0.5],
                                ['.rapid-pro-F .box2', { opacity: 0 }, { opacity: 1 }, 0.5],
                            ],
                        }),
                    );
                }
                return () => {
                    sceneArr?.forEach((scene: any) => scene.destory());
                };
            } else {
                setEnter(true);
            }
        }
    }, [locale]);

    return (
        <div id="rapid-pro-F" className={`rapid-pro-F ${css.section} GtmModuleData-section`} data-section-id={`rapid-pro-F`} data-section-title={t('F_title')}>
            <div className="sticky">
                {locale !== 'ph' && (
                    <div className="box box1">
                        <div className="img">
                            <EcoImg
                                pc="https://websiteoss.ecoflow.com/upload/image/1749880801965/62.jpg"
                                pad="https://websiteoss.ecoflow.com/upload/image/1749880801965/62.jpg"
                                h5="https://websiteoss.ecoflow.com/upload/image/1749880801808/61-h5.jpg"
                            />
                        </div>
                        <div className={`info ${enter ? 'enter' : ''}`}>
                            <p className="info-title">{t('F_box1_title')}</p>
                            <p className="info-desc">{t('F_box1_desc')}</p>
                            <div className="info-param">
                                <p className="info-param-unit">{t('F_box1_unit2')}</p>
                                <p className="info-param-num">{t('F_box1_num')}</p>
                                <p className="info-param-unit">{t('F_box1_unit')}</p>
                            </div>
                        </div>
                    </div>
                )}
                <div className="box box2">
                    <div className="img">
                        <EcoImg
                            pc="https://websiteoss.ecoflow.com/upload/image/1749009150678/6_2.jpg"
                            pad="https://websiteoss.ecoflow.com/upload/image/1749009150678/6_2.jpg"
                            h5="https://websiteoss.ecoflow.com/upload/image/1749009150872/6_2_M.jpg"
                        />
                    </div>
                    <div className={`info ${enter ? 'enter' : ''}`}>
                        <p className="info-title">{t('F_box2_title')}</p>
                        <p className="info-desc">{t('F_box2_desc')}</p>
                        <p className="info-tip">{t('F_box2_tip')}</p>
                        <div className="info-param">
                            <p className="info-param-unit">{t('F_box2_unit2')}</p>
                            <p className="info-param-num">{t('F_box2_num')}</p>
                            <p className="info-param-unit">{t('F_box2_unit')}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default F;
